import { render, staticRenderFns } from "./ItemUserConnected.vue?vue&type=template&id=0c40560a"
import script from "./ItemUserConnected.vue?vue&type=script&lang=js"
export * from "./ItemUserConnected.vue?vue&type=script&lang=js"
import style0 from "./ItemUserConnected.vue?vue&type=style&index=0&id=0c40560a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports